import { render, staticRenderFns } from "./table_shenghe.vue?vue&type=template&id=093232a1&scoped=true&"
import script from "./table_shenghe.vue?vue&type=script&lang=js&"
export * from "./table_shenghe.vue?vue&type=script&lang=js&"
import style0 from "./table_shenghe.vue?vue&type=style&index=0&id=093232a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093232a1",
  null
  
)

export default component.exports